/* Custom Hero carousel — Embla main carousel synced with a thumbnail strip,
   dot indicators, and desktop prev/next arrows (assets/embla-carousel.js,
   UMD global `EmblaCarousel`). */

(function () {
  function initSection(root) {
    if (root.dataset.emblaReady || typeof EmblaCarousel === 'undefined') return;

    var viewport = root.querySelector('[data-hero-viewport]');
    var thumbsViewport = root.querySelector('[data-hero-thumbs-viewport]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hero-thumb]'));
    var prevButton = root.querySelector('[data-hero-prev]');
    var nextButton = root.querySelector('[data-hero-next]');
    var dotsContainer = root.querySelector('[data-hero-dots]');
    if (!viewport) return;

    var embla = EmblaCarousel(viewport, {
      align: 'start',
      containScroll: 'trimSnaps',
    });

    var emblaThumbs = null;
    if (thumbsViewport) {
      emblaThumbs = EmblaCarousel(thumbsViewport, {
        align: 'start',
        containScroll: 'keepSnaps',
        dragFree: true,
      });
    }

    var dots = [];

    function buildDots() {
      dotsContainer.innerHTML = '';
      dots = embla.scrollSnapList().map(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'custom-hero__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        dot.addEventListener('click', function () {
          embla.scrollTo(index);
        });
        dotsContainer.appendChild(dot);
        return dot;
      });
    }

    function update() {
      var selected = embla.selectedScrollSnap();
      dots.forEach(function (dot, index) {
        dot.classList.toggle('custom-hero__dot--active', index === selected);
      });
      thumbs.forEach(function (thumb, index) {
        thumb.classList.toggle('custom-hero__thumb--active', index === selected);
      });
      if (emblaThumbs) emblaThumbs.scrollTo(selected);
      if (prevButton) prevButton.disabled = !embla.canScrollPrev();
      if (nextButton) nextButton.disabled = !embla.canScrollNext();
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        embla.scrollTo(index);
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        embla.scrollPrev();
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        embla.scrollNext();
      });
    }

    embla.on('select', update);
    embla.on('reInit', function () {
      buildDots();
      update();
    });

    buildDots();
    update();
    root.dataset.emblaReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-hero]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
